import React, { useState, useEffect, useContext, useMemo,useRef } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tmdbApi from "../../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Loader from "../../components/loader";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { useNavigate, useLocation } from "react-router-dom";


import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  Legend,
  ResponsiveContainer,
} from "recharts";

let { lambda, appname } = window.app



const views = ['DAY', 'WEEK', 'MONTH', 'YEAR'];


const DashBoard = () => {
  const navigate = useNavigate();
  const [view, setView] = useState("DAY");
  const [filterType, setFilterType] = useState("Total");
  const [xAxisData, setXAxisData] = useState([]);
  const [transactionsData, setTransactionsData] = useState([])
  const [chartData, setChartData] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [locationData, setLocationData] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [dateRange, setDateRange] = useState({ fromDate: '', toDate: '' });
  const [selectedType, setSelectedType] = useState("Total");
  const [show, setShow] = useState(false)
  const [summary, setSummary] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, clientInfo, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
  const useruniqueid = localStorage.getItem("clientid")
  const [selectedMode, setSelectedMode] = useState("Day");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [range1, setRange1] = useState({ fromDate: '', toDate: '' });
  const [range2, setRange2] = useState({ fromDate: '', toDate: '' });
  const [currentData, setCurrentData] = useState([]);
  const [compareData, setCompareData] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false)
  const [clientData, setClientData] = useState([])
  const [image, setImg] = useState('')
  const calendarRef = useRef(null);
  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const paymentNotSuccess = clientInfo?.subscriptionPayment !== "PAYMENT SUCCESS";
  //   // const hasSubscriptionPrice = clientInfo?.subscriptionPrice !== "0" && clientInfo?.subscriptionPrice !== 0;

  //   if (!token || (paymentNotSuccess )) {
  //     navigate("/signin");
  //   }
  // }, [clientInfo]);

  useEffect(() => {
    client()
    getTransactionData()
    getCounts()
  }, [])

  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }



  }, [window.site]);


  const getTransactionData = () => {
    setIsLoading(true);
    // console.log('Client call');
    let url;
    let page = 1;


    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");


    url = lambda + '/allTransactions?appname=' + appname + "&token=" + token;


    axios({
      method: 'POST',
      url: url
    })
      .then(function (response) {

        // If token validation is needed:
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true);
        } else {

          setTransactionsData(response?.data?.result?.transactions?.slice(0, 5))


          setIsLoading(false)
          // setColumns(clientsColumns)
          // global.exportExcelData = response?.data?.result?.data;
          // setContent(response?.data?.result);
        }

      })
      .catch((err) => {
        console.log('Error:', err);
        setIsLoading(false);
      });
  };


  // Here Start Admin Dashboard Chart data


  const transactions = [
    { id: '25222', name: 'JOHN', plan: 'PRO PLAN', amount: '$199' },
    { id: '25223', name: 'ALEXANDRA', plan: 'PREMIUM PLAN', amount: '$299' },
    { id: '25224', name: 'ANGELA', plan: 'PRO PLAN', amount: '$199' },
    { id: '25225', name: 'CHLOE', plan: 'PRO PLAN', amount: '$199' },
  ];

  const columns = [
    // {
    //   name: 'ID',
    //   selector: row => row.trasactionId,
    //   sortable: true,
    //   width: '100px',
    // },
    {
      name: 'NAME',
      selector: row => row?.address?.firstName,
      sortable: true,
    },
    {
      name: 'PLAN TYPE',
      selector: row => row?.subscription,
      sortable: true,
    },
    {
      name: 'AMOUNT',
      selector: row => row?.payAmount,
      sortable: true,
      right: true,
    },
  ];


  const clientColumns = [
    // { name: 'SL.NO', selector: (row, index) => index + 1, sortable: true, width: '80px' },
    { name: 'NAME', selector: row => row.name, sortable: true },
    // { name: 'EMAIL', selector: row => row.emailId, sortable: true },
    // { name: 'PHONE NUMBER', selector: row => row.phone, sortable: true },
    // { name: 'CREATED DATE', selector: row => row?.created ? new Date(row.created).toLocaleDateString('en-GB') : "", sortable: true },

    { name: 'NO. OF STORES', selector: row => row.storeCounts, sortable: true, right: true },
    { name: 'Revenue', selector: row => row.commissionRevenue, sortable: true },
    {
      name: 'ACTIONS',
      cell: row => <button className="view-btn dashboard-btn" onClick={() => handleViewDashboard(row?.clientid)}><span class="material-symbols-outlined dashboard-icon">
        equalizer
      </span>Dashboard</button>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  // Here Stop Admin Dashboard Chart data
const handleClickOutside = (e) => {
    if (calendarRef.current && !calendarRef.current.contains(e.target)) {
      setShowCalendar(false);
    }
  };
 useEffect(() => {
    if (showCalendar) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCalendar]);


const getDatePickerProps = () => {
    if (view === "Day") {
      return {
        dateFormat: "dd/MM/yyyy",
      };
    } else if (view === "WEEK") {
      return {
        filterDate: isMonday,
        placeholderText: "Select Monday",
        dateFormat: "dd/MM/yyyy",
      };
    } else if (view === "MONTH") {
      return {
        showMonthYearPicker: true,
        dateFormat: "MMMM yyyy", // ⬅️ Will show "May 2025" instead of "05/2025"
      };
    } else if (view === "YEAR") {
      return {
        showYearPicker: true,
        dateFormat: "yyyy",
      };
    }
  };

  const filteredData = useMemo(() => {
    const key = selectedType.toLowerCase(); // e.g., "total", "completed", etc.

    return chartData.map(item => ({
      ...item,
      [key]: selectedType === "Total" ? item.total : (item[key] > 0 ? item[key] : null),
    }));
  }, [selectedType, chartData]);

  const data = [
    { day: 'Mon', week1: 5, week2: -4 },
    { day: 'Tue', week1: 3, week2: -6 },
    { day: 'Wed', week1: 4, week2: -2 },
    { day: 'Thu', week1: 0, week2: 0 },
    { day: 'Fri', week1: 2, week2: -3 },
    { day: 'Sat', week1: 0, week2: 0 },
    { day: 'Sun', week1: 1, week2: -1 },
  ];
  const isWeekData = currentData.length === 7;

  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getWeekdayName = (dateStr) => {
    const fullDate = new Date(`${dateStr}, 2024`);
    return weekDays[fullDate.getDay()];
  };

  const getDayNumber = (dateStr) => {
    const parts = dateStr.split(" ");
    return parts[1]; // e.g., "May 01" → "01"
  };

  const mergedData = currentData.map((item, index) => {
    const r2 = compareData[index];

    let nameLabel;

    if (isWeekData) {
      nameLabel = getWeekdayName(item.name);
    } else if (/\w+\s\d{2}/.test(item.name)) {
      nameLabel = getDayNumber(item.name);
    } else {
      nameLabel = item.name;
    }

    return {
      name: nameLabel,
      completedPositive: item.completed,
      activePositive: item.active,
      cancelledPositive: item.cancelled,
      expiredPositive: item.expired,
      completedNegative: -r2.completed,
      activeNegative: -r2.active,
      cancelledNegative: -r2.cancelled,
      expiredNegative: -r2.expired,
    };
  });


  // Transform the 'previous' dataset to negative for bottom display
  const transformedData = data.map((d) => ({
    ...d,
    previous: -d.previous,
  }));

  const centerYAxisPosition = 150;
  // console.log("filterrrrrrrrrrrrrrrrrrrrrrrrrData", filteredData)
  const StackedBarChart = ({ }) => {
    // console.log("View:", view);

    // Set barSize based on view
    let barSize = 20; // Default for DAY
    let interval
    if (view === "WEEK") {
      barSize = 80;
    } else if (view === "MONTH") {
      barSize = 50;
      interval = 0
    } else if (view === "YEAR") {
      barSize = 70;
    }

    return (
      <ResponsiveContainer width="100%" height={350}>
        {currentData?.length > 0 && compareData?.length > 0 ?
          <BarChart data={mergedData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            {/* <Legend /> */}

            {/* Completed Bars */}
            {(selectedType === "Total" || selectedType === "Completed") && (
              <>
                <Bar dataKey="completedPositive" stackId="a" fill="#b187f4" isAnimationActive />
                <Bar dataKey="completedNegative" stackId="b" fill="#b187f4" isAnimationActive />
              </>
            )}

            {/* Active Bars */}
            {(selectedType === "Total" || selectedType === "Active") && (
              <>
                <Bar dataKey="activePositive" stackId="a" fill="#ec90d0" isAnimationActive />
                <Bar dataKey="activeNegative" stackId="b" fill="#ec90d0" isAnimationActive />
              </>
            )}

            {/* Cancelled Bars */}
            {(selectedType === "Total" || selectedType === "Cancelled") && (
              <>
                <Bar dataKey="cancelledPositive" stackId="a" fill="#8bd1ff" isAnimationActive />
                <Bar dataKey="cancelledNegative" stackId="b" fill="#8bd1ff" isAnimationActive />
              </>
            )}

            {/* Expired Bars */}
            {(selectedType === "Total" || selectedType === "Expired") && (
              <>
                <Bar dataKey="expiredPositive" stackId="a" fill="#f7d26e" isAnimationActive />
                <Bar dataKey="expiredNegative" stackId="b" fill="#f7d26e" isAnimationActive />
              </>
            )}
          </BarChart> :
          <BarChart data={filteredData} barSize={barSize}>
            <CartesianGrid strokeDasharray="7 7" vertical={false} horizontal={true} />
            <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} interval={interval} />
            <YAxis />
            <Tooltip />

            {(selectedType === "Total" || selectedType === "Completed") && (
              <Bar dataKey="completed" stackId="a" fill="#b187f4" isAnimationActive />
            )}
            {(selectedType === "Total" || selectedType === "Active") && (
              <Bar dataKey="active" stackId="a" fill="#ec90d0" isAnimationActive />
            )}
            {(selectedType === "Total" || selectedType === "Cancelled") && (
              <Bar dataKey="cancelled" stackId="a" fill="#8bd1ff" isAnimationActive />
            )}
            {(selectedType === "Total" || selectedType === "Expired") && (
              <Bar dataKey="expired" stackId="a" fill="#f7d26e" isAnimationActive />
            )}
          </BarChart>}





      </ResponsiveContainer>


    );
  };
  const getCurrentMonday = () => {
    const today = new Date();
    const day = today.getDay();
    const diff = day === 0 ? -6 : 1 - day; // Adjust for Sunday (0)
    return new Date(today.setDate(today.getDate() + diff));
  };


  // console.log("rangeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee1", range1)
  // console.log("rangeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee2", range2)


  // Update default dates based on selected mode
  useEffect(() => {
    const now = new Date();

    if (selectedMode === "Day") {
      setFromDate(now);
      setToDate(now);
    } else if (selectedMode === "Week") {
      const monday = getCurrentMonday();
      setFromDate(monday);
      setToDate(monday);
    } else if (selectedMode === "Month") {
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      setFromDate(firstDay);
      setToDate(firstDay);
    } else if (selectedMode === "Year") {
      const janFirst = new Date(now.getFullYear(), 0, 1);
      setFromDate(janFirst);
      setToDate(janFirst);
    }
  }, [selectedMode]);

  // Filter only Mondays for Week mode
  const isMonday = (date) => {
    return date.getDay() === 1;
  };
  const client = (e) => {
    // console.log('client call')
    GetTimeActivity()
    let page = 1;
    //  setCurrentPage(1);
    // setIsLoading(true);
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    axios({
      method: 'get',
      url: lambda + '/clientCounts?appname=' + appname,
    })
      .then(function (response) {
        // console.log("response", response?.data?.result?.data);
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {

          setClientData(response?.data?.result?.slice(0, 5));

          // setIsLoading(false);

        }

      }).catch((err) => {
        console.log('error', err);
        // setTableErrMsg(true)
        setIsLoading(false);
      });
  }
  // DatePicker props based on selected mode
  const getPickerProps = () => {
    if (selectedMode === "Day") {
      return {
        dateFormat: "dd/MM/yyyy",
      };
    } else if (selectedMode === "Week") {
      return {
        filterDate: isMonday,
        placeholderText: "Select Monday",
        dateFormat: "dd/MM/yyyy",
      };
    } else if (selectedMode === "Month") {
      return {
        showMonthYearPicker: true,
        dateFormat: "MMMM yyyy", // ⬅️ Will show "May 2025" instead of "05/2025"
      };
    } else if (selectedMode === "Year") {
      return {
        showYearPicker: true,
        dateFormat: "yyyy",
      };
    }
  };


  const handleCompare = () => {
    setShow(true)
  }


  const getDateRange = (view, currentDate) => {
    let start = new Date(currentDate);
    let end = new Date(currentDate);

    if (view === 'WEEK') {
      const day = start.getDay(); // 0 (Sun) to 6 (Sat)
      const diff = start.getDate() - day + (day === 0 ? -6 : 1); // Monday as the first day of the week
      start.setDate(diff);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
    } else if (view === 'MONTH') {
      start.setDate(1);
      end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
    } else if (view === 'YEAR') {
      start = new Date(start.getFullYear(), 0, 1);
      end = new Date(start.getFullYear(), 11, 31);
    }

    const format = (date, isStart) => {
      const y = date.getFullYear();
      const m = `${date.getMonth() + 1}`.padStart(2, '0');
      const d = `${date.getDate()}`.padStart(2, '0');
      return `${y}-${m}-${d}T${isStart ? '00:00:00' : '23:59:59'}`;
    };

    const startDateStr = format(start, true);
    const endDateStr = format(end, false);

    return {
      fromDate: startDateStr,
      toDate: endDateStr,
      groupBy: view.toLowerCase()
    };
  };
  useEffect(() => {
    if (view && currentDate) {
      const dateRangeData = getDateRange(view, currentDate);
      
      const payload = selectedStoreId
        ? { ...dateRangeData, storeId: selectedStoreId }
        : dateRangeData;

      dashboard(payload); // Call API with correct data
      // counts(payload);
    }
  }, [view, currentDate]); // Add selectedStoreId to dependencies


  // const dateRangeData = getDateRange(view, currentDate);





  useEffect(() => {
    setRoute("user")
    // GetUserData();
    setActiveMenuId(200000)
    // setActiveMenuObj({
    //     "Client Management": false,
    //     "Contact Management":false,
    //     "Reports": false
    // })
    // setData([])
    userActivity();
  }, []);
  const userActivity = () => {
    let path = window.location.pathname.split("/");
    const pageName = path[path.length - 1];
    var presentTime = moment();
    let payload;

    payload = {
      "clientid": localStorage.getItem("clientid"),
      "pagename": pageName,
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    const previousId = localStorage.getItem("previousid");
    const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response?.data?.statusCode === 200) {
          localStorage.setItem("previousid", response?.data?.result)
        }
      });
  }
  // console.log("chartDatatatattatatatatata", chartData)
  const shiftDate = (date) => {
    const today = new Date();
    if (date > today) return; // Block future dates

    const newDate = new Date(date);

    if (view === 'DAY') {
      newDate.setDate(newDate.getDate());
    } else if (view === 'WEEK') {
      newDate.setDate(newDate.getDate());
    } else if (view === 'MONTH') {
      newDate.setMonth(newDate.getMonth());
    } else if (view === 'YEAR') {
      newDate.setFullYear(newDate.getFullYear());
    }

    setCurrentDate(newDate);
    setSelectedType("Total");
    setChartData([]);
    setShowCalendar(false);
  };

  const typeKeyMap = {
    Total: 'totalCount',
    Active: 'activeCount',
    Completed: 'completedCount',
    Cancelled: 'cancelledCount',
    Expired: 'expiredCount',
  };
  const formatDate = (date, isStart = true) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}T${isStart ? '00:00:00' : '23:59:59'}`;
  };
  const getRangeByModeFromDate = (mode, fromDate) => {
    let from = new Date(fromDate);
    let to = new Date(fromDate);

    if (mode === "Day") {
      // same day
      to = new Date(from);
    } else if (mode === "Week") {
      to.setDate(to.getDate() + 6);
    } else if (mode === "Month") {
      from = new Date(from.getFullYear(), from.getMonth(), 1);
      to = new Date(from.getFullYear(), from.getMonth() + 1, 0);
    } else if (mode === "Year") {
      from = new Date(from.getFullYear(), 0, 1);
      to = new Date(from.getFullYear(), 11, 31);
    }

    return {
      fromDate: formatDate(from, true),
      toDate: formatDate(to, false),
      groupBy: mode,
    };
  };

  const getRangeByModeToDate = (mode, toDate) => {
    let from = new Date(toDate);
    let to = new Date(toDate);

    if (mode === "Day") {
      from = new Date(to);
    } else if (mode === "Week") {
      to.setDate(to.getDate() + 6);
    } else if (mode === "Month") {
      from = new Date(to.getFullYear(), to.getMonth(), 1);
      to = new Date(to.getFullYear(), to.getMonth() + 1, 0);
    } else if (mode === "Year") {
      from = new Date(to.getFullYear(), 0, 1);
      to = new Date(to.getFullYear(), 11, 31);
    }

    return {
      fromDate: formatDate(from, true),
      toDate: formatDate(to, false),
      groupBy: mode,
    };
  };



  // This updates range1 and sets it to state
  const updateRange1FromDate = (from) => {
    const r1 = getRangeByModeFromDate(selectedMode, from);
    setRange1({ ...r1, groupBy: selectedMode?.toLowerCase() });
  };

  // This updates range2 and sets it to state
  const updateRange2FromDate = (to) => {
    const r2 = getRangeByModeToDate(selectedMode, to);

    setRange2({ ...r2, groupBy: selectedMode?.toLowerCase() });
  };

  // Handlers called by date pickers
  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (date) updateRange1FromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    if (date) updateRange2FromDate(date);
  };

  // Update ranges whenever fromDate or selectedMode changes
  useEffect(() => {
    if (!fromDate) return;
    updateRange1FromDate(fromDate);
  }, [fromDate, selectedMode]);

  // Update ranges whenever toDate or selectedMode changes
  useEffect(() => {
    if (!toDate) return;
    updateRange2FromDate(toDate);
  }, [toDate, selectedMode]);

  const getLabel = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const current = new Date(currentDate);
    current.setHours(0, 0, 0, 0);

    const formatShort = (date) =>
      date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

    const formatRange = (start, end) => `${formatShort(start)} ~ ${formatShort(end)}`;

    if (view === 'DAY') {
      const diffDays = Math.floor((current - today) / (1000 * 60 * 60 * 24));
      if (diffDays === 0) return `${current.toDateString()} (Today)`;
      if (diffDays === -1) return `${current.toDateString()} (Yesterday)`;
      if (diffDays === 1) return `${current.toDateString()} (Tomorrow)`;
      return current.toDateString();
    }

    if (view === 'WEEK') {
      const getMonday = (date) => {
        const d = new Date(date);
        const day = d.getDay(); // Sunday=0, Monday=1 ... Saturday=6
        const diff = (day === 0 ? -6 : 1) - day; // If Sunday (0), go back 6 days, else go back to Monday
        d.setDate(d.getDate() + diff);
        d.setHours(0, 0, 0, 0);
        return d;
      };

      const currentWeekStart = getMonday(current);
      const currentWeekEnd = new Date(currentWeekStart);
      currentWeekEnd.setDate(currentWeekStart.getDate() + 6);
      currentWeekEnd.setHours(0, 0, 0, 0);

      const todayWeekStart = getMonday(today);

      const diffWeeks = Math.floor((currentWeekStart - todayWeekStart) / (7 * 24 * 60 * 60 * 1000));

      if (diffWeeks === 0) return 'Current Week';
      if (diffWeeks === -1) return 'Last Week';
      if (diffWeeks === 1) return 'Next Week';

      return formatRange(currentWeekStart, currentWeekEnd);
    }


    if (view === 'MONTH') {
      const diffMonths =
        (current.getFullYear() - today.getFullYear()) * 12 + (current.getMonth() - today.getMonth());

      const start = new Date(current.getFullYear(), current.getMonth(), 1);
      const end = new Date(current.getFullYear(), current.getMonth() + 1, 0);

      if (diffMonths === 0) return 'Current Month';
      if (diffMonths === -1) return 'Last Month';
      if (diffMonths === 1) return 'Next Month';

      return formatRange(start, end);
    }

    if (view === 'YEAR') {
      const year = current.getFullYear();
      const currentYear = today.getFullYear();

      const start = new Date(year, 0, 1);
      const end = new Date(year, 11, 31);

      const diffYears = year - currentYear;

      if (diffYears === 0) return 'Current Year';
      if (diffYears === -1) return 'Last Year';
      if (diffYears === 1) return 'Next Year';

      return formatRange(start, end);
    }

    return '';
  };


  const handleViewChange = (selectedView) => {
    setView(selectedView);
    setCurrentDate(new Date());
    //  setChartData([])
    setSelectedType("Total")
    // You can add other logic here if needed in the future
  };

  const dashboard = async (data) => {
    // setIsLoading(true)
     const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await tmdbApi.revenueSummary(
       { ...data,timeZone:timeZone}
      );
      setChartData(response?.result)
      // console.log(response);
      // setChartData(response?.result?.result)
      // setSummary(response?.result?.summary)
      setCurrentData([])
      setCompareData([])
      // setIsLoading(false)

      // Example conditional navigation (uncomment and customize as needed):
      // if (response?.result === "PENDING APPROVAL") {
      //   setBtnLoader(false);
      //   navigate("/thankyou");
      // } else {
      //   setBtnLoader(false);
      //   navigate("/verifyaccount");
      // }

    } catch (error) {
      console.error("Error in dashboard API call:", error);
      // Optionally, you can also:
      // setBtnLoader(false);
      // show error to user
    }
  };

  const getCounts = async () => {
    // setIsLoading(true)
    try {
      const response = await tmdbApi.getRevenueCounts(

      );

      // console.log(response);
      // setChartData(response?.result?.result)
      setSummary(response?.result)
      setCurrentData([])
      setCompareData([])
      // setIsLoading(false)

      // Example conditional navigation (uncomment and customize as needed):
      // if (response?.result === "PENDING APPROVAL") {
      //   setBtnLoader(false);
      //   navigate("/thankyou");
      // } else {
      //   setBtnLoader(false);
      //   navigate("/verifyaccount");
      // }

    } catch (error) {
      console.error("Error in dashboard API call:", error);
      // Optionally, you can also:
      // setBtnLoader(false);
      // show error to user
    }
  };

  const handleStoreChange = (e) => {
    setSelectedStoreId(e.target.value);

    console.log("Selected Store ID:", e.target.value);
  };
  const handleFilterClick = (type) => setSelectedType(type);
  const handleClickCompare = async () => {
    setBtnLoader(true);

    let payload, payload1;

    if (selectedStoreId?.length > 0) {
      payload = { ...range1, storeid: selectedStoreId };
      payload1 = { ...range2, storeid: selectedStoreId };
    } else {
      payload = range1;
      payload1 = range2;
    }

    try {
      const response = await tmdbApi.dashboard(payload);
      const response1 = await tmdbApi.dashboard(payload1);

      setCurrentData(response?.result?.result);
      setCompareData(response1?.result?.result);
      setShow(false);
    } catch (error) {
      console.error("Error in dashboard API call:", error);
    }

    setBtnLoader(false);
  };

  const customNoRecords = (message = "No records found") => {
    return (
      <div className="empty-state-body empty-record">
        <div className="empty-state__message">
          <span className="material-icons">summarize</span>
          <p className="form-check font-size-16">{message}</p>
        </div>
      </div>
    );
  };

  const handleView = () => {
    navigate("/transactions")
  }
  const handleViewDashboard = (Id) => {
    navigate("/viewdashboard/" + Id)
  }
  const handleClientsView = () => {
    navigate("/clients")
  }
  const handleCancel = () => {

    const today = new Date();
    setView("DAY")
    setCurrentDate(today);
    const defaultMode = "Day"; // use "day" or "Day" based on your logic
    setSelectedMode(defaultMode);

    // reset date pickers
    setFromDate(today);
    setToDate(today);

    // reset range1 and range2
    const r1 = getRangeByModeFromDate(defaultMode, today);
    const r2 = getRangeByModeToDate(defaultMode, today);

    setRange1({ ...r1, groupBy: defaultMode.toLowerCase() });
    setRange2({ ...r2, groupBy: defaultMode.toLowerCase() });


    // optionally reset current store
    // setCurrentStore(""); or keep currentStore unchanged
  };
  const handleEdit = () => {
    setShow(true)
  }
  // console.log("image",image)
  return (
    <>
     {showSessionPopupup && <SessionPopup />}
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        {isLoading ? <Loader /> :
          <div className="main-content user-management" id="dashboard-main-content">
          <div className="page-content" id="dashboard-page-content">
            <div className="container-fluid" id="dashboard-container">
              <div className="row breadcrumb" id="dashboard-breadcrumb-row">
                <div className="col-lg-12">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <h4 className="mb-2 card-title" id="dashboard-title">DASHBOARD</h4>
                    </div>
                  </div>
                </div>
              </div>
        
              <div className="p-4 bg-white shadow-lg rounded-lg row Dashboard-wrapper admin-dashboard-wrapper" id="dashboard-wrapper">
        
                <div className="col-md-3">
                  <div className="card dashboard-box features-box" id="this-month-revenue-card">
                    <div className="card-body">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="feu-txt-18" id="this-month-revenue-label">This Month Revenue</p>
                          <h4 className="feu-txt-20" id="this-month-revenue-value">
                            {`$ ${summary?.totalMonthlyRevenue?.toLocaleString()}`}
                          </h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <div className="feu-icon-section">
                            <img
                              src={`${image}${appname}/images/web/Month Revenue.svg`}
                              alt="Logo"
                              id="this-month-revenue-icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        
                <div className="col-md-3">
                  <div className="card dashboard-box features-box" id="total-revenue-card">
                    <div className="card-body">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="feu-txt-18" id="total-revenue-label">Total Revenue</p>
                          <h4 className="feu-txt-20" id="total-revenue-value">
                            {`$ ${summary?.totalRevenue?.toLocaleString()}`}
                          </h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <div className="feu-icon-section t-revenue">
                            <img
                              src={`${image}${appname}/images/web/Total Revenue.svg`}
                              alt="Logo"
                              id="total-revenue-icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        
                <div className="col-md-3">
                  <div className="card dashboard-box features-box" id="total-stores-card">
                    <div className="card-body">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="feu-txt-18" id="total-stores-label">Total Stores</p>
                          <h4 className="feu-txt-20" id="total-stores-value">{summary?.totalStores}</h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <div className="feu-icon-section location-icon">
                            <img
                              src={`${image}${appname}/images/web/Total Store.svg`}
                              alt="Logo"
                              id="total-stores-icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        
                <div className="col-md-3">
                  <div className="card dashboard-box features-box" id="total-visitors-card">
                    <div className="card-body">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="feu-txt-18" id="total-visitors-label">Total Visitors</p>
                          <h4 className="feu-txt-20" id="total-visitors-value">{summary?.totalVisitors}</h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <div className="feu-icon-section visitor-icon">
                            <img
                              src={`${image}${appname}/images/web/Total Visitor.svg`}
                              alt="Logo"
                              id="total-visitors-icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        
                <div className="col-md-12 mt-3" id="revenue-chart-card">
                  <div className="card dashboard-box revenue-chart">
                    <div className="card-body">
                      <div className="row mb-3">
                        <div className="mb-3 col-md-6" id="chart-legend">
                          <div className="d-flex">
                            <div className="d-flex justify-content-center align-items-center">
                              <span className="commision-badge me-2"></span>
                              <span className="me-4">Commision Revenue $</span>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                              <span className="subscription-badge me-2"></span>
                              <span>Subscription Revenue $</span>
                            </div>
                          </div>
                        </div>
        
                        <div className="col-md-6 date-wrapper d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap gap-2" id="chart-date-wrapper">
                          <div className="btn-group" role="group" id="view-toggle-group">
                            {views.map((viewOption) => (
                              <button
                                key={viewOption}
                                className={`btn btn-style ${view === viewOption ? 'active' : ''}`}
                                id={`view-btn-${viewOption.toLowerCase()}`}
                                onClick={() => handleViewChange(viewOption)}
                              >
                                {viewOption.charAt(0) + viewOption.slice(1).toLowerCase()}
                              </button>
                            ))}
                          </div>
        
                          <div className="d-flex align-items-center gap-1 date-selecting-wrapper" id="date-selecting-wrapper">
                            <span
                              className="px-3 py-2 rounded-lg text-sm fw-semibold"
                              id="date-label"
                              onClick={() => setShowCalendar(!showCalendar)}
                            >
                              {getLabel()}
                            </span>
                            {showCalendar && (
                              <div
                                className="position-absolute bg-white shadow p-2 mt-2 rounded"
                                style={{ zIndex: 10, top: 33 }}
                                id="calendar-popup"
                              >
                                <div ref={calendarRef}>
                                  <DatePicker
                                    className="form-control custom-date"
                                    inline
                                    selected={currentDate}
                                    onChange={shiftDate}
                                    {...getDatePickerProps()}
                                    popperProps={{
                                      modifiers: [
                                        {
                                          name: 'preventOverflow',
                                          options: {
                                            boundary: 'viewport',
                                          },
                                        },
                                      ],
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
        
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={chartData} barCategoryGap={0} barGap={0} id="revenue-bar-chart">
                          <XAxis dataKey="name" interval={0} angle={-45} textAnchor="end" height={60} />
                          <YAxis />
                          <Tooltip />
                          <Bar dataKey="commission" fill="#a78bfa" name="Commission Revenue $" barSize={10} />
                          <Bar dataKey="subscription" fill="#c084fc" name="Subscription Revenue $" barSize={10} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
        
                <div className="col-md-6 mt-3" id="latest-transactions-card">
                  <div className="card dashboard-box transaction-section">
                    <div className="card-body transaction-wrapper">
                      <div className="d-flex justify-content-between mb-3">
                        <h2 className="sm-heading" id="latest-transactions-heading">Latest Transactions</h2>
                        <p className="view-btn" id="view-all-transactions-btn" onClick={handleView}>View All</p>
                      </div>
                      <DataTable
                        columns={columns}
                        data={transactionsData}
                        noDataComponent={customNoRecords("No transactions found")}
                      />
                    </div>
                  </div>
                </div>
        
                <div className="col-md-6 mt-3" id="top-clients-card">
                  <div className="card dashboard-box clients-table">
                    <div className="card-body">
                      <div className="d-flex justify-content-between mb-3">
                        <h2 className="sm-heading" id="top-clients-heading">Top 5 Clients</h2>
                        <p className="view-btn" id="view-all-clients-btn" onClick={handleClientsView}>View All</p>
                      </div>
                      <DataTable
                        columns={clientColumns}
                        data={clientData}
                        noDataComponent={customNoRecords("No clients were found")}
                        highlightOnHover
                        striped
                      />
                    </div>
                  </div>
                </div>
        
              </div>
        
              <Modal show={show} onHide={() => setShow(false)} centered className="compare-modal" id="compare-modal">
                <Modal.Header closeButton className="header-style" id="compare-modal-header">
                  <Modal.Title>COMPARE</Modal.Title>
                </Modal.Header>
                <Modal.Body id="compare-modal-body">
                  <div className="compare-body">
                    <div className="btn-group align-items-center" role="group" id="compare-mode-group">
                      {["Day", "Week", "Month", "Year"].map((mode) => (
                        <button
                          key={mode}
                          className={`btn btn-style ${selectedMode === mode ? "active" : ""}`}
                          id={`compare-mode-${mode.toLowerCase()}-btn`}
                          onClick={() => setSelectedMode(mode)}
                        >
                          {mode}
                        </button>
                      ))}
                    </div>
        
                    <div className="date-input" id="compare-date-input">
                      <div className="input-group custom-date-wrapper" id="from-date-wrapper">
                        <DatePicker
                          className="form-control custom-date"
                          selected={fromDate}
                          onChange={handleFromDateChange}
                          {...getPickerProps()}
                          popperProps={{
                            modifiers: [
                              {
                                name: 'preventOverflow',
                                options: {
                                  boundary: 'viewport',
                                },
                              },
                            ],
                          }}
                        />
                      </div>
                      <p className="to-text">To</p>
                      <div className="input-group custom-date-wrapper" id="to-date-wrapper">
                        <DatePicker
                          className="form-control custom-date"
                          selected={toDate}
                          onChange={handleToDateChange}
                          {...getPickerProps()}
                          popperProps={{
                            modifiers: [
                              {
                                name: 'preventOverflow',
                                options: {
                                  boundary: 'viewport',
                                },
                              },
                            ],
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-end pt-0" id="compare-modal-footer">
                  <button className="fill-btn save_continue" id="compare-submit-btn" onClick={handleClickCompare} disabled={btnLoader}>
                    {btnLoader ? (
                      <img
                        src={`${image}${appname}/images/web/rotate_right.svg`}
                        className="loading-icon"
                        id="compare-loading-icon"
                      />
                    ) : null}
                    COMPARE
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
        }
      </div>
    </>
  );
};

export default DashBoard;
